import { render, staticRenderFns } from "./RankWeekly.vue?vue&type=template&id=6858a3ce&scoped=true"
import script from "./RankWeekly.vue?vue&type=script&lang=js"
export * from "./RankWeekly.vue?vue&type=script&lang=js"
import style0 from "./RankWeekly.vue?vue&type=style&index=0&id=6858a3ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6858a3ce",
  null
  
)

export default component.exports